import UIAutoComplete from '@/components/Shared/CustomComponents/UIAutoComplete.vue'
import UIButton from '@/components/Shared/CustomComponents/UIButton.vue'
import UICheckbox from '@/components/Shared/CustomComponents/UICheckbox.vue'
import UIColorPicker from '@/components/Shared/CustomComponents/UIColorPicker.vue'
import UIDatePicker from '@/components/Shared/CustomComponents/UIDatePicker.vue'
import UIDropdown from '@/components/Shared/CustomComponents/UIDropdown.vue'
import UIEditor from '@/components/Shared/CustomComponents/UIEditor.vue'
import UIEmailChipInput from '@/components/Shared/CustomComponents/UIEmailChipInput.vue'
import UIErrorMessage from '@/components/Shared/CustomComponents/UIErrorMessage.vue'
import UIFieldInfo from '@/components/Shared/CustomComponents/UIFieldInfo.vue'
import UIGroup from '@/components/Shared/CustomComponents/UIGroup.vue'
import UIGrouper from '@/components/Shared/CustomComponents/UIGrouper.vue'
import UIImageCropper from '@/components/Shared/CustomComponents/UIImageCropper.vue'
import UIInfo from '@/components/Shared/CustomComponents/UIInfo.vue'
import UIInput from '@/components/Shared/CustomComponents/UIInput.vue'
import UILineMessage from '@/components/Shared/CustomComponents/UILineMessage.vue'
import UILoader from '@/components/Shared/CustomComponents/UILoader.vue'
import UIModal from '@/components/Shared/CustomComponents/UIModal.vue'
import UIPagination from '@/components/Shared/CustomComponents/UIPagination.vue'
import UIProgress from '@/components/Shared/CustomComponents/UIProgress.vue'
import UISearchBox from '@/components/Shared/CustomComponents/UISearchBox.vue'
import UISelect from '@/components/Shared/CustomComponents/UISelect.vue'
import UISteppers from '@/components/Shared/CustomComponents/UISteppers.vue'
import UISwitch from '@/components/Shared/CustomComponents/UISwitch.vue'
import UITable from '@/components/Shared/CustomComponents/UITable.vue'
import UITableSelection from '@/components/Shared/CustomComponents/UITableSelection.vue'
import UITextbox from '@/components/Shared/CustomComponents/UITextbox.vue'
import UITimePicker from '@/components/Shared/CustomComponents/UITimePicker.vue'
import UIToggler from '@/components/Shared/CustomComponents/UIToggler.vue'
import UITooltip from '@/components/Shared/CustomComponents/UITooltip.vue'

import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  install(Vue: any) {
    Vue.component('ui-table', UITable)
    Vue.component('ui-table-selection', UITableSelection)
    Vue.component('ui-button', UIButton)
    Vue.component('ui-input', UIInput)
    Vue.component('ui-select', UISelect)
    Vue.component('ui-checkbox', UICheckbox)
    Vue.component('ui-auto-complete', UIAutoComplete)
    Vue.component('ui-email-chip-input', UIEmailChipInput)
    Vue.component('ui-switch', UISwitch)
    Vue.component('ui-loader', UILoader)
    Vue.component('ui-pagination', UIPagination)
    Vue.component('ui-modal', UIModal)
    Vue.component('ui-date-picker', UIDatePicker)
    Vue.component('ui-line-message', UILineMessage)
    Vue.component('ui-tooltip', UITooltip)
    Vue.component('ui-dropdown', UIDropdown)
    Vue.component('ui-textbox', UITextbox)
    Vue.component('ui-steppers', UISteppers)
    Vue.component('ui-editor', UIEditor)
    Vue.component('ui-image-cropper', UIImageCropper)
    Vue.component('ui-error-message', UIErrorMessage)
    Vue.component('ui-field-info', UIFieldInfo)
    Vue.component('ui-color-picker', UIColorPicker)
    Vue.component('ui-time-picker', UITimePicker)
    Vue.component('ui-info', UIInfo)
    Vue.component('ui-search-box', UISearchBox)
    Vue.component('ui-group', UIGroup)
    Vue.component('ui-grouper', UIGrouper)
    Vue.component('ui-progress', UIProgress)
    Vue.component('ui-toggler', UIToggler)
    Vue.use(VueViewer)
  },
}
